"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _lodash = require("lodash");
const _constants = require("../../constants");
const _jsonSchemas = require("./jsonSchemas");
const INPUTS_SCHEMA_ID = "InputArray";
const clientSchemaMerge = (srcSchema, clientOverrides)=>{
    return (0, _lodash.merge)({}, srcSchema, {
        properties: {
            inputType: undefined
        }
    }, clientOverrides);
};
const clientNumberSchema = clientSchemaMerge(_jsonSchemas.numberSchema, {
    properties: {
        // custom number schema to include "prefixPostfix" property
        prefixPostfix: {
            type: "object",
            properties: {
                label: {
                    type: "string",
                    minLength: 1
                },
                value: {
                    type: "string",
                    minLength: 1
                }
            }
        },
        defaultValue: {
            type: "number",
            minimum: {
                $data: "1/minimum"
            },
            maximum: {
                $data: "1/maximum"
            }
        },
        // Read more about $data here: https://ajv.js.org/guide/combining-schemas.html#data-reference
        minimum: {
            type: "number",
            exclusiveMaximum: {
                $data: "1/maximum"
            }
        },
        maximum: {
            type: "number",
            exclusiveMinimum: {
                $data: "1/minimum"
            }
        }
    }
});
const clientNumberWithUnitsSchema = clientSchemaMerge(_jsonSchemas.numberWithUnitsSchema, {
    properties: {
        defaultValue: {
            type: "number",
            minimum: {
                $data: "1/minimum"
            },
            maximum: {
                $data: "1/maximum"
            }
        },
        // Read more about $data here: https://ajv.js.org/guide/combining-schemas.html#data-reference
        minimum: {
            type: "number",
            exclusiveMaximum: {
                $data: "1/maximum"
            }
        },
        maximum: {
            type: "number",
            exclusiveMinimum: {
                $data: "1/minimum"
            }
        }
    }
});
// custom group schema to override the default for validating group inputs
// while going field-by-field
const clientGroupSchema = clientSchemaMerge(_jsonSchemas.groupSchema, {
    properties: {
        properties: {
            $ref: INPUTS_SCHEMA_ID,
            type: "array",
            items: {
                type: "object"
            },
            minItems: 1
        }
    }
});
const formSchema = {
    title: "Root Fields",
    type: "object",
    properties: {
        name: {
            type: "string",
            minLength: 1
        },
        description: {
            type: [
                "string",
                "null"
            ]
        },
        hiddenFromPublicByDefault: {
            type: "boolean"
        },
        successMessage: {
            type: [
                "string",
                "null"
            ]
        },
        preamble: {
            type: [
                "string",
                "null"
            ]
        },
        postamble: {
            type: [
                "string",
                "null"
            ]
        },
        notificationEmails: {
            type: [
                "string",
                "null"
            ]
        },
        category: {
            type: "string",
            minLength: 1
        },
        canCreateRolesAndGroupIds: {
            type: "array",
            items: {
                type: "string"
            },
            minItems: 1
        },
        modules: {
            type: "array",
            items: {
                type: "string",
                enum: Object.values(_constants.SUBMISSION_TYPE_MODULE)
            }
        },
        attachments: {
            type: "array",
            minItems: 1,
            items: {
                type: "object",
                discriminator: {
                    propertyName: "type"
                },
                oneOf: [
                    _jsonSchemas.customMapGeometryAttachmentSchema,
                    _jsonSchemas.propertyAttachmentSchema
                ]
            }
        },
        inputs: {
            $id: INPUTS_SCHEMA_ID,
            type: "array",
            items: {
                type: "object",
                discriminator: {
                    propertyName: "inputType"
                },
                oneOf: [
                    _jsonSchemas.documentUploaderSchema,
                    _jsonSchemas.tagsSchema,
                    _jsonSchemas.selectSchema,
                    _jsonSchemas.dateSchema,
                    _jsonSchemas.damageDegreeSchema,
                    _jsonSchemas.textSchema,
                    _jsonSchemas.textAreaSchema,
                    clientNumberSchema,
                    _jsonSchemas.booleanInputSchema,
                    clientNumberWithUnitsSchema,
                    _jsonSchemas.propertyMarketValueSchema,
                    clientGroupSchema,
                    _jsonSchemas.userSchema,
                    _jsonSchemas.multiSelectSchema,
                    _jsonSchemas.uniqueIdSchema
                ]
            },
            minItems: 1
        }
    },
    required: [
        "name",
        "category",
        "canCreateRolesAndGroupIds",
        "inputs",
        "attachments"
    ],
    additionalProperties: false
};
const _default = formSchema;

//# sourceMappingURL=data:application/json;base64,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